module.exports = __webpack_public_path__ + "static/media14-c56a498ff96016d2f7d37b534d0c9d4e.png";